'use client';

import { useEffect } from 'react';
import { NotFoundPage } from '@/components/NotFoundPage';

/**
 * Error boundary for [locale]: shows the same 404 page for all 4XX-style errors
 * (and any unhandled errors) so users see a consistent experience.
 */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return <NotFoundPage onRetry={reset} />;
}
